export type OptimizelyVariableTypes = boolean | number | string | object;
export enum Splits {
    REVIEWS_APP_AI_AUTO_PROCESS_FLOW = 'reviews-app-ai-auto-process-flow',
}

export type ReviewsAppAiAutoProcessFlowConfig = {
    autopublish: boolean;
};
